<template>
  <div style="display: inline-block; white-space: nowrap;">
    <b-btn
      v-b-tooltip.hover
      variant="none"
      class="btn-none rounded-pill m-0 icone-acao p-0"
      title="Download"
      @click="baixarExcelEmpresa(gridProps.row)"
    >
      <feather-icon
        icon="DownloadIcon"
        class="text-primary"
        size="20"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      title="Observação"
      variant="none"
      class="text-primary btn-none"
      style="padding: 0.2rem;"
      @click="openModalObservacao"
    >
      <font-awesome-icon
        icon="fa-regular fa-message"
        :class="{
          'text-success': todasObservacoesLidas,
          'text-warning': !todasObservacoesLidas && temObservacaoNova,
          'text-primary': !todasObservacoesLidas && !temObservacaoNova
        }"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      title="Enviar por e-mail"
      variant="none"
      class="btn-none icone-acao m-0 p-0"
      @click="openModalEnviarDocs()"
    >
      <feather-icon
        icon="SendIcon"
        class="text-primary"
        size="20"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      variant="none"
      title="Histórico por rotina"
      class="btn-none icone-acao m-0 p-0"
      @click="abrirRelatorio(gridProps.row)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        class="text-primary"
      />
    </b-btn>
    <button
      v-b-tooltip.hover="{ boundary: 'window' }"
      title="Enviar por WhatsApp"
      style="font-size: 11.5px; padding: .1rem"
      class="btn btn-sm"
      @click="openWhatsApp(gridProps.row)"
    >
      <font-awesome-icon
        icon="fa-brands fa-whatsapp"
        class="text-primary"
        style="font-size: 18px"
      />
    </button>

    <relatorios
      v-if="mostrarRelatorio"
      :empresa="empresa"
      :filtro="montarDoc(empresa.id)"
      @hidden="fecharModal()"
    />
    <envio-email
      ref="modalEnvioEmail"
      :title="`Enviar Documentos ${gridProps.row.razaoSocial}`"
      :sugestao="gridProps.row.email"
      :sugestao-email-adicional="gridProps.row.emailAdicionalEmpresa"
      @enviarEmail="enviarDocumentos"
    />
    <modal-observacao
      ref="modalObservacao"
      v-model="gridProps.row"
      :api="api"
      :notificar="{ sucesso: notficarSucesso, erro: notificarErro }"
      @change="receberObservacao"
      @hidden="fecharObservacao($event)"
    />
    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Aguarde'"
    />
  </div>
</template>

<style lang="scss">
</style>

<script>
import moment from 'moment'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    Relatorios: () => import('../retatorio/Relatorios.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
    api: {
      type: Object,
      required: true,
    },
    filtrosRapidos: {
      type: Array,
      default: () => [],
    },
    filtrosTipoRotina: {
      type: Array,
      default: () => [],
    },
    filtroAtual: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      faExternalLinkAlt,
      mostarArquivo: false,
      arquivo: {},
      isLoading: false,
      mostrarRelatorio: false,
      empresa: {},
    }
  },
  computed: {
    temObservacaoNova() {
      return this.gridProps?.row?.temObservacoesNaoLidas ?? false
    },
    todasObservacoesLidas() {
      return this.gridProps?.row?.todasObservacoesLidas ?? false
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    openModalEnviarDocs() {
      this.$refs.modalEnvioEmail.abrirModal()
    },
    enviarDocumentos(itens) {
      if (itens.emailsPara.length === 0 && itens.emailsCc.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Informe ao menos um e-mail',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        this.$emit('enviar-email', { linha: this.gridProps.row, email: itens })
      }
    },
    baixarExcelEmpresa(linha) {
      this.isLoading = true
      this.api.baixarExcelEmpresa(this.montarDoc(linha.id), linha.id)
        .then(payload => {
          this.arquivo = payload.data
          window.open(this.arquivo.url)
          this.api.deletarExcel(this.arquivo.url, this.arquivo.nomeArquivo)
          this.arquivo.url = ''
          this.$sucesso('Download finalizado.')
        })
        .catch(err => {
          this.isLoading = false
          this.$erro(err.message || 'Ocorreu um erro no download.')
          throw err
        })
      this.isLoading = false
    },
    openModalObservacao() {
      this.$refs.modalObservacao.show()
    },
    fecharObservacao(observacaoNova) {
      this.gridProps.row.temObservacoesNaoLidas = observacaoNova.hasObservacaoNova
      this.gridProps.row.todasObservacoesLidas = observacaoNova.observacaoLida
      this.gridProps.row.observacao = ''
    },
    receberObservacao(valor) {
      this.gridProps.row.observacao = valor
    },
    abrirRelatorio(linha) {
      this.empresa = linha
      this.mostrarRelatorio = true
    },
    openWhatsApp(row) {
      if (row !== undefined) {
        this.montarMensagemWhatsApp(row)
      } else {
        this.$erro(`Não há nenhuma ${this.rotina} selecionada para envio!`)
      }
    },
    montarMensagemWhatsApp(row) {
      const dias = 15
      this.isLoading = true
      const mensagem = `Olá *${row.razaoSocial}* segue link para download do arquivo com Histórico do consumo de créditos por rotina.\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\n O link ficará disponível até ${moment().add(dias, 'days').format('DD/MM/YYYY')}\r\n`
      this.api.baixarExcelEmpresa(this.montarDoc(row.id), row.id)
        .then(payload => {
          this.isLoading = false
          this.$swal({
            width: 680,
            title: '<div class="text-secondary">Mensagem</div>',
            html: `<div class="text-primary">${(mensagem.replace(/\r\n/g, '<br>'))} <a href="${payload.data.url}" target="_blank" class="text-secondary" style="text-decoration: underline;">Link do arquivo</a></div>`,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Copiar link',
            denyButtonText: 'WhatsApp',
            cancelButtonText: 'Cancelar',
            buttonsStyling: false,
            customClass: {
              denyButton: 'btn btn-primary mr-50',
              confirmButton: 'btn btn-outline-primary mr-50',
              cancelButton: 'btn btn-outline-danger mr-50',
            },
            allowOutsideClick: true,
          }).then(result => {
            if (result.isConfirmed) {
              this.$swal('Copiado!', '', 'success')
              navigator.clipboard.writeText(payload.data.url)
            } else if (result.isDenied) {
              const url = `https://wa.me/?text=${encodeURIComponent(`${mensagem}${payload.data.url}`)}`
              window.open(url)
            }
          })
        })
        .catch(err => {
          this.isLoading = false
          this.$erro(`Erro ao encaminhar mensagem via WhatsApp: ${err}.`, err)
        })
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    fecharModal() {
      this.mostrarRelatorio = false
      this.empresaSelecionada = null
    },
    montarDoc(id) {
      return {
        Agrupamento: undefined,
        Docs: this.filtrosTipoRotina,
        Empresas: [id],
        Filtro: this.filtroAtual,
      }
    },
  },
}
</script>
